// components/SectionCard.tsx
import { Card, Divider, Typography } from 'antd';
import { FC, ReactNode } from 'react';

const { Title, Text } = Typography;

interface SectionCardProps {
  index?: number; // e.g. 1, 2, 3...
  title: string;
  subtitle?: string;
  children: ReactNode;
  extra?: ReactNode;
}

const SectionCard: FC<SectionCardProps> = ({
  index,
  title,
  subtitle,
  children,
  extra,
}) => {
  return (
    <Card
      size="small"
      bordered={false}
      style={{
        borderRadius: 12,
        boxShadow: '0 6px 18px rgba(15, 23, 42, 0.06)',
        background: '#ffffff',
      }}
      bodyStyle={{ padding: 15 }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: 12,
        }}
      >
        <div>
          {index && (
            <Text
              type="secondary"
              style={{
                fontSize: 12,
                textTransform: 'uppercase',
                letterSpacing: 0.08,
              }}
            >
              Section {index}
            </Text>
          )}
          <Title
            level={4}
            style={{
              margin: 0,
              marginTop: 4,
              // left accent via border
              borderLeft: '3px solid #05a2e4',
              paddingLeft: 8,
            }}
          >
            {title}
          </Title>
          {subtitle && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              {subtitle}
            </Text>
          )}
        </div>
        {extra}
      </div>

      <Divider style={{ margin: '12px 0 16px' }} />

      {children}
    </Card>
  );
};

export default SectionCard;
